import { OtsUIState } from "../../ots-ui-store";

export const selectMeterFlowVolumeReviewPageFilter = (state: OtsUIState) => state.uiMeterFlowVolumeReviewPage.filter
